import moment from 'moment';

import { EButton, EDateInput, EFormSection, EPageTitle, ESelect, ETextInput } from 'libs/ui';

import PageLayout from 'PageLayout';

import useCreateNewPaymentRequest from './Hooks/useCreateNewPaymentRequest';

export default function CreateNewPaymentRequest() {

    const {
        navigate,
        DEPOSIT_TYPE_OPTIONS,
        state,
        dispatch,
        saveRequest
    } = useCreateNewPaymentRequest();

    return (
        <PageLayout>
            <EPageTitle
                title="Create New Payment Request"
                end={
                    <div>
                        <EButton
                            variant="outline"
                            disabled={state.isLoading}
                            onClick={() => navigate(-1)}
                        >Cancel</EButton>
                        <EButton
                            className="ml-3"
                            loading={state.isLoading}
                            onClick={saveRequest}
                        >Save</EButton>
                    </div>
                }
            />

            <div>
                <EFormSection
                    fullWidth
                    title="Deposit Details"
                    subtitle="All fields marked with * are mandatory"
                >
                    <div className="grid grid-cols-3 gap-5">
                        <ESelect
                            label="Deposit Type"
                            placeholder="Select"
                            data={DEPOSIT_TYPE_OPTIONS}
                            required={state.rules.depositType === "YES"}
                            value={state.details.depositType}
                            error={state.errors.depositType}
                            onChange={value => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "depositType", value }
                            })}
                        />
                        <ETextInput
                            label="Deposit Amount"
                            placeholder="Ex: 1000"
                            required={state.rules.depositAmount === "YES"}
                            value={state.details.depositAmount}
                            error={state.errors.depositAmount}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "depositAmount", value: e ? +e.target.value : 0 }
                            })}
                        />
                        <EDateInput
                            label="Date of Deposit"
                            placeholder="Select"
                            maxDate={new Date()}
                            required={state.rules.dateOfDeposit === "YES"}
                            value={state.details.dateOfDeposit ? new Date(state.details.dateOfDeposit) : null}
                            error={state.errors.dateOfDeposit}
                            onChange={value => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "dateOfDeposit", value: value ? moment(value).format("YYYY-MM-DD") : null }
                            })}
                        />
                    </div>
                </EFormSection>

                <EFormSection
                    fullWidth
                    title="Beneficiary Details"
                    subtitle="Beneficiary bank details"
                >
                    <div className="grid grid-cols-3 gap-5">
                        <ETextInput
                            label="Beneficiary Bank"
                            placeholder="Enter Bank Name"
                            required={state.rules.beneficiaryBank === "YES"}
                            value={state.details.beneficiaryBank ?? undefined}
                            error={state.errors.beneficiaryBank}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "beneficiaryBank", value: e.target.value }
                            })}
                        />
                        <ETextInput
                            label="Beneficiary Name"
                            placeholder="Enter Beneficiary Name"
                            required={state.rules.beneficiaryName === "YES"}
                            value={state.details.beneficiaryName ?? undefined}
                            error={state.errors.beneficiaryName}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "beneficiaryName", value: e.target.value }
                            })}
                        />
                    </div>
                </EFormSection>

                <EFormSection
                    fullWidth
                    title="Cheque Details"
                    subtitle="Cheque details"
                >
                    <div className="grid grid-cols-3 gap-5">
                        <ETextInput
                            label="Cheque Number"
                            placeholder="Enter Bank Name"
                            required={state.rules.chequeDdNumber === "YES"}
                            value={state.details.chequeDdNumber ?? undefined}
                            error={state.errors.chequeDdNumber}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "chequeDdNumber", value: e.target.value }
                            })}
                        />
                        <EDateInput
                            label="Cheque Dd Issue Date"
                            placeholder="Select"
                            maxDate={new Date()}
                            required={state.rules.chequeDdIssueDate === "YES"}
                            value={state.details.chequeDdIssueDate ? new Date(state.details.chequeDdIssueDate) : null}
                            error={state.errors.chequeDdIssueDate}
                            onChange={value => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "chequeDdIssueDate", value: value ? moment(value).format("YYYY-MM-DD") : null }
                            })}
                        />
                    </div>
                </EFormSection>

                <EFormSection
                    fullWidth
                    title="Deposit Bank Details"
                    subtitle="Depositor bank details"
                >
                    <div className="grid grid-cols-3 gap-5">
                        <ETextInput
                            label="Deposit Bank Name"
                            placeholder="Enter Bank Name"
                            required={state.rules.depositorBankName === "YES"}
                            value={state.details.depositorBankName ?? undefined}
                            error={state.errors.depositorBankName}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "depositorBankName", value: e.target.value }
                            })}
                        />
                        <ETextInput
                            label="Deposit Bank Branch"
                            placeholder="Enter Bank Branch"
                            required={state.rules.depositorBankBranch === "YES"}
                            value={state.details.depositorBankBranch ?? undefined}
                            error={state.errors.depositorBankBranch}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "depositorBankBranch", value: e.target.value }
                            })}
                        />
                        <ETextInput
                            label="Deposit Bank Account Number"
                            placeholder="Enter Bank Account Number"
                            required={state.rules.depositorBankAccountNumber === "YES"}
                            value={state.details.depositorBankAccountNumber ?? undefined}
                            error={state.errors.depositorBankAccountNumber}
                            onChange={e => dispatch({
                                action: "UPDATE_DETAILS",
                                payload: { field: "depositorBankAccountNumber", value: e.target.value }
                            })}
                        />
                    </div>
                </EFormSection>
            </div>
        </PageLayout>
    )
}